var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroundingTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 84,
    viewBox: "0 0 307 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1256_2288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.588 61.42C147.695 61.42 146.941 61.54 146.328 61.78C145.715 62.0067 145.221 62.2333 144.848 62.46L145.308 64.26C145.548 64.1267 145.821 63.98 146.128 63.82C146.448 63.66 146.801 63.5267 147.188 63.42C147.575 63.3 147.995 63.24 148.448 63.24C149.141 63.24 149.701 63.3867 150.128 63.68C150.568 63.96 150.788 64.3933 150.788 64.98C150.788 65.2733 150.708 65.58 150.548 65.9C150.388 66.2067 150.155 66.5267 149.848 66.86C149.541 67.18 149.168 67.5333 148.728 67.92L144.588 71.5V73H153.368L153.068 71.28H147.628L149.868 69.42C150.588 68.8067 151.155 68.26 151.568 67.78C151.981 67.2867 152.281 66.8067 152.468 66.34C152.655 65.86 152.748 65.34 152.748 64.78C152.748 64.1 152.575 63.5067 152.228 63C151.895 62.4933 151.415 62.1067 150.788 61.84C150.175 61.56 149.441 61.42 148.588 61.42ZM157.175 68.76C157.282 68.56 157.502 68.3533 157.835 68.14C158.169 67.9267 158.575 67.82 159.055 67.82C159.695 67.82 160.222 68.0267 160.635 68.44C161.049 68.84 161.255 69.4133 161.255 70.16C161.255 70.92 161.002 71.5267 160.495 71.98C159.989 72.42 159.349 72.64 158.575 72.64C157.935 72.64 157.382 72.5667 156.915 72.42C156.449 72.2733 155.955 72.0533 155.435 71.76L154.335 73.32C154.709 73.52 155.122 73.7133 155.575 73.9C156.042 74.0867 156.522 74.2333 157.015 74.34C157.522 74.46 158.015 74.52 158.495 74.52C159.509 74.52 160.375 74.3267 161.095 73.94C161.829 73.5667 162.389 73.0533 162.775 72.4C163.162 71.7333 163.355 70.9867 163.355 70.16C163.355 69.4133 163.189 68.7267 162.855 68.1C162.535 67.46 162.055 66.9533 161.415 66.58C160.775 66.1933 159.955 66 158.955 66C158.662 66 158.369 66.04 158.075 66.12C157.795 66.1867 157.529 66.2867 157.275 66.42L157.415 63.52H162.375L162.615 61.68H155.475L155.135 68.76H157.175Z",
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6504 61.42C60.7571 61.42 60.0037 61.54 59.3904 61.78C58.7771 62.0067 58.2837 62.2333 57.9104 62.46L58.3704 64.26C58.6104 64.1267 58.8837 63.98 59.1904 63.82C59.5104 63.66 59.8637 63.5267 60.2504 63.42C60.6371 63.3 61.0571 63.24 61.5104 63.24C62.2037 63.24 62.7637 63.3867 63.1904 63.68C63.6304 63.96 63.8504 64.3933 63.8504 64.98C63.8504 65.2733 63.7704 65.58 63.6104 65.9C63.4504 66.2067 63.2171 66.5267 62.9104 66.86C62.6037 67.18 62.2304 67.5333 61.7904 67.92L57.6504 71.5V73H66.4304L66.1304 71.28H60.6904L62.9304 69.42C63.6504 68.8067 64.2171 68.26 64.6304 67.78C65.0437 67.2867 65.3437 66.8067 65.5304 66.34C65.7171 65.86 65.8104 65.34 65.8104 64.78C65.8104 64.1 65.6371 63.5067 65.2904 63C64.9571 62.4933 64.4771 62.1067 63.8504 61.84C63.2371 61.56 62.5037 61.42 61.6504 61.42ZM67.3979 67.28C67.3979 68.44 67.6312 69.4733 68.0979 70.38C68.5646 71.2733 69.2046 71.98 70.0179 72.5C70.8446 73.0067 71.7912 73.26 72.8579 73.26C73.9112 73.26 74.8512 73 75.6779 72.48C76.5046 71.96 77.1512 71.2467 77.6179 70.34C78.0846 69.4333 78.3179 68.4 78.3179 67.24C78.3179 66.12 78.0846 65.12 77.6179 64.24C77.1512 63.36 76.5046 62.6733 75.6779 62.18C74.8646 61.6733 73.9246 61.42 72.8579 61.42C71.8046 61.42 70.8646 61.6733 70.0379 62.18C69.2246 62.6867 68.5779 63.38 68.0979 64.26C67.6312 65.14 67.3979 66.1467 67.3979 67.28ZM69.4979 67.22C69.4979 66.46 69.6446 65.7933 69.9379 65.22C70.2312 64.6467 70.6312 64.1867 71.1379 63.84C71.6446 63.4933 72.2179 63.32 72.8579 63.32C73.5246 63.32 74.1112 63.4933 74.6179 63.84C75.1246 64.1867 75.5246 64.66 75.8179 65.26C76.1112 65.86 76.2579 66.5467 76.2579 67.32C76.2579 68.0933 76.1112 68.7867 75.8179 69.4C75.5246 70 75.1246 70.4733 74.6179 70.82C74.1112 71.1667 73.5312 71.34 72.8779 71.34C72.2246 71.34 71.6446 71.1667 71.1379 70.82C70.6312 70.46 70.2312 69.9733 69.9379 69.36C69.6446 68.7333 69.4979 68.02 69.4979 67.22Z",
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.729 61.42C232.929 61.42 232.189 61.5467 231.509 61.8C230.829 62.04 230.182 62.36 229.569 62.76L230.629 64.28C230.975 64.04 231.409 63.8067 231.929 63.58C232.462 63.3533 233.042 63.24 233.669 63.24C234.109 63.24 234.482 63.3133 234.789 63.46C235.109 63.6067 235.349 63.8067 235.509 64.06C235.682 64.3133 235.769 64.5867 235.769 64.88C235.769 65.44 235.509 65.8933 234.989 66.24C234.469 66.5733 233.769 66.74 232.889 66.74H231.729L232.049 68.48H232.769C233.902 68.48 234.722 68.68 235.229 69.08C235.749 69.48 236.009 70.0133 236.009 70.68C236.009 71.0933 235.882 71.4533 235.629 71.76C235.389 72.0667 235.075 72.3 234.689 72.46C234.315 72.62 233.915 72.7 233.489 72.7C232.862 72.7 232.315 72.6267 231.849 72.48C231.382 72.3333 230.889 72.1067 230.369 71.8L229.229 73.32C229.802 73.6267 230.462 73.9 231.209 74.14C231.955 74.3933 232.702 74.52 233.449 74.52C234.395 74.52 235.215 74.3467 235.909 74C236.615 73.6667 237.155 73.2067 237.529 72.62C237.915 72.0333 238.109 71.38 238.109 70.66C238.109 70.1 238.002 69.6 237.789 69.16C237.589 68.72 237.329 68.36 237.009 68.08C236.702 67.8 236.395 67.6267 236.089 67.56C236.395 67.44 236.682 67.2467 236.949 66.98C237.215 66.7133 237.435 66.3933 237.609 66.02C237.782 65.6467 237.869 65.2533 237.869 64.84C237.869 64.24 237.715 63.68 237.409 63.16C237.102 62.6267 236.642 62.2067 236.029 61.9C235.415 61.58 234.649 61.42 233.729 61.42ZM239.32 67.28C239.32 68.44 239.553 69.4733 240.02 70.38C240.486 71.2733 241.126 71.98 241.94 72.5C242.766 73.0067 243.713 73.26 244.78 73.26C245.833 73.26 246.773 73 247.6 72.48C248.426 71.96 249.073 71.2467 249.54 70.34C250.006 69.4333 250.24 68.4 250.24 67.24C250.24 66.12 250.006 65.12 249.54 64.24C249.073 63.36 248.426 62.6733 247.6 62.18C246.786 61.6733 245.846 61.42 244.78 61.42C243.726 61.42 242.786 61.6733 241.96 62.18C241.146 62.6867 240.5 63.38 240.02 64.26C239.553 65.14 239.32 66.1467 239.32 67.28ZM241.42 67.22C241.42 66.46 241.566 65.7933 241.86 65.22C242.153 64.6467 242.553 64.1867 243.06 63.84C243.566 63.4933 244.14 63.32 244.78 63.32C245.446 63.32 246.033 63.4933 246.54 63.84C247.046 64.1867 247.446 64.66 247.74 65.26C248.033 65.86 248.18 66.5467 248.18 67.32C248.18 68.0933 248.033 68.7867 247.74 69.4C247.446 70 247.046 70.4733 246.54 70.82C246.033 71.1667 245.453 71.34 244.8 71.34C244.146 71.34 243.566 71.1667 243.06 70.82C242.553 70.46 242.153 69.9733 241.86 69.36C241.566 68.7333 241.42 68.02 241.42 67.22Z",
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 272,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 289,
    y: 25,
    width: 1.5,
    height: 25,
    rx: 0.75,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.148484,
    x: 306,
    y: 25,
    width: 1,
    height: 25,
    rx: 0.5,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    width: 2,
    height: 50,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 10,
    width: 2,
    height: 40,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 10,
    width: 2,
    height: 40,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.148484,
    y: 25,
    width: 1,
    height: 25,
    rx: 0.5,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 17,
    y: 25,
    width: 1.5,
    height: 25,
    rx: 0.75,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 34,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 25,
    width: 2,
    height: 25,
    rx: 1,
    fill: "#282860"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1256_2288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 307,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundingTimer);
export default __webpack_public_path__ + "static/media/groundingTimer.f6fd4927c6f3c2b6c88e3382e423deca.svg";
export { ForwardRef as ReactComponent };